// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setItemToLocalStorage = (key: string, value: string) => {
  localStorage.setItem(key, value);
};

export const getItemFromLocalStorage = (key: string) =>
  localStorage.getItem(key);

export const removeItemFromLocalStorage = (key: string) =>
  localStorage.removeItem(key);

export const setItemToSessionStorage = (key: string, value: string) => {
  sessionStorage.setItem(key, value);
};

export const getItemFromSessionStorage = (key: string) =>
  sessionStorage.getItem(key);
